import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";

// CSS
import "../../styles/newDesign.scss";
import "./Footer.scss";

// A phone number with only digits (leading zero dropped, Egypt country code assumed like the
// reference design's own wa.me link) -- wa.me needs a bare international-format number, no "+",
// spaces or a local leading 0.
function waNumber(mobile) {
  if (!mobile) return null;
  const digits = mobile.replace(/\D/g, "");
  if (!digits) return null;
  return digits.startsWith("20") ? digits : `20${digits.replace(/^0/, "")}`;
}

class Footer extends Component {
  render() {
    const { tenant } = this.props;
    const teacherName = (tenant && tenant.name) || "";
    const wa = tenant && waNumber(tenant.mobile);

    return (
      <div className="nd-page">
        <footer className="site-footer">
          <div className="nd-wrap footer-inner">
            <Link to="/" className="footer-brand">
              {tenant && tenant.image ? (
                <img className="footer-logo" src={tenant.image} alt={teacherName} />
              ) : (
                <span className="footer-brand-name">{teacherName}</span>
              )}
            </Link>
            <nav className="footer-nav">
              <NavLink exact to="/">Home</NavLink>
              <NavLink to="/courses">Courses</NavLink>
              <NavLink to="/gallery">Gallery</NavLink>
              <NavLink to="/about">About</NavLink>
              <NavLink to="/resources">Resources</NavLink>
              <NavLink to="/contact">Contact</NavLink>
              <NavLink to="/privacy">Privacy</NavLink>
              <NavLink to="/terms">Terms</NavLink>
            </nav>
            <div className="footer-copy">© {new Date().getFullYear()} {teacherName}. All rights reserved.</div>
          </div>
        </footer>

        {wa && (
          <a
            href={`https://wa.me/${wa}`}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-float"
            aria-label="Chat on WhatsApp"
          >
            <i className="fab fa-whatsapp"></i>
          </a>
        )}
      </div>
    );
  }
}

export default Footer;
